<template>
    <div class="resourceBox overflow_hide">
        <div class="unCollect" v-if="resource.length===0">暂无数据</div>
        <div v-for="c in resource" :key="c.id"
             class="resource-single fl">
            <div class="checkMask" @click="choose(c)" v-if="checkMode&&$route.path.indexOf('PersonalResource')>0">
                <i class="el-icon-success" :style="c.active?'color:greenyellow':'color:white'"/>
            </div>
            <router-link
                    class="link"
                    :to="'/CourseInfo/'+c.id"
                    target="_blank">
                <div class="img-box"><img v-lazy="serverIp+c.imageUrl"></div>
                <div class="resource">
                    <!--<div class="view">浏览量:{{c.pageviews}}</div>-->
                    <div class="resource-name">{{c.name}}</div>
                    <!--<div class="resource-info" v-if="c.description!=null">{{c.description}}</div>-->
                </div>
            </router-link>
            <!--<div @click="del(c.id)" v-if="$route.path.indexOf('PersonalResource')>0">删除</div>-->
        </div>
        <Pagination
                v-if="resource.length>0&&exist"
                class="pagination"
                :pageLimit=pageSize
                :current-page.sync="currentPage"
                :size="size"
                @changeCurrent="changeCurrent"/>
    </div>
</template>

<script>
    import Pagination from './Pagination'

    export default {
        name: "ResourceList",
        props: ["resource", "pageSize",'size'],
        data() {
            return {
                checkMode:false,
                chooseArr:[],
                currentPage:1,
                exist:true
            }
        },
        components: {Pagination},
        filters:{
            //进行文字数量管控
            sizeControl(data){
                if(data.length>50){
                    return data.substring(0,50) + "..."
                }else return data
            }
        },
        methods: {
            changeCurrent(data) {
                this.currentPage = data;
                this.$emit("changeCurrent",data);
            },
            del(id){
                this.$emit("del",id);
            },
            choose(r){
                this.$nextTick(()=> {
                    this.$set(r, 'active', !r.active);
                });
            }
        },
        watch:{
            'resource':{
                handler:function(data){
                    let arr = [];
                    for(let i in data) {
                        if (data[i].active) {
                            arr.push(data[i].id);
                        }
                    }
                    this.chooseArr=arr;
                },
                deep:true
            }
        }
    }
</script>

<style scoped lang="less">
    .unCollect{margin:20px 0;}
    .resource-single {
        width: 280px;
        height: 200px;
        cursor: pointer;
        margin:0 0 20px;
        position: relative;
        &:not(:nth-child(4n+1)){
            margin-left:60px;
        }
        .checkMask{
            position: absolute;
            top: 0;
            i{
                position: absolute;
                right:0;
            }
        }
        .checkMask ,img {
            width: 280px;
            max-width:280px;
            height: 160px;
        }

    }

    .resource {
        background-color: #f8f8f8;
        height: 40px;
        position: relative;
        .view{
            height:20px;
            width: 100px;
            position: absolute;
            right:0;
            top:-20px;
            background-color: #0558e4;
            color:#fff;
            font-size:14px;
            text-align: left;
            text-indent: 5px;
        }
        .resource-name:before{
            content: "课程名称:";
            color: #0558e4
        }
        .resource-name{
            font-size: 16px;
            text-align: left;
            height:20px;
        }
        .resource-info{
            font-size: 14px;
            text-align: left;
            height: 60px;
            overflow: hidden;
        }

        .resource-info:before {
            content: "课程信息:";
            color: #0558e4
        }

        .upload-info {
            font-size: 12px;
            height:auto
        }
    }

    .pagination{margin:20px 0;}

    .img-box{
        max-width:100%;
        overflow: hidden;
    }
    .link:hover{
        .img-box{
            img{
                transform: scale(1.1);
                transition: all .5s;
            }
        }
    }
</style>
